// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { MediaQuery, Markdown, ExpandableOverflow } from '@riseart/common';

import {
  raScreenXsMax,
  raScreenSm,
  raScreenMdMax,
} from '@riseart/antd-provider/dist/website/variables.less';
import { collectionDescriptionCls } from 'shared_components/collections/containers/description/Description.less';

const EXPANDABLE_HEIGHT = {
  small: 75,
  medium: 125,
  large: 200,
};

type Props = {
  children?: string,
  expandableHeight?: { small: number, medium: number, large: number },
};

/**
 * CollectionDescription
 *
 * @param {Props} props
 */
export const CollectionDescription = ({
  children,
  expandableHeight = EXPANDABLE_HEIGHT,
}: Props): Node => {
  const maxHeight = { ...EXPANDABLE_HEIGHT, ...expandableHeight };

  return children ? (
    <div className={collectionDescriptionCls}>
      <MediaQuery maxWidth={raScreenXsMax}>
        {(isSm) => (
          <MediaQuery minWidth={raScreenSm} maxWidth={raScreenMdMax}>
            {(isMd) => (
              <ExpandableOverflow
                maxHeight={
                  (isSm && maxHeight.small) || (isMd && maxHeight.medium) || maxHeight.large
                }
                gradientColor="gray"
                showMore={<FormattedMessage id="common.show_more" />}
                showLess={<FormattedMessage id="common.show_less" />}
              >
                <Markdown text={children} />
              </ExpandableOverflow>
            )}
          </MediaQuery>
        )}
      </MediaQuery>
    </div>
  ) : null;
};
